import { ObjectUtils, UriHelper, Utils, Logger } from "neo-common";

export type AnimationScriptAnimationFactory = any;
export type LoadAnimationAssetCallback = (assetId: string, assetPath: string) => void;

export class AnimationScriptManager {
    static Scripts: { [id: string]: AnimationScriptAnimationFactory } = {};

    private static _cachedInstances: { [id: string]: PIXI.extras.AnimatedSprite } = {};

    static cleanup() {
        AnimationScriptManager.Scripts = null;
    }

    public static addScript(
        id: string,
        factory: AnimationScriptAnimationFactory,
        baseUrl: string,
        loadAssetCallback: LoadAnimationAssetCallback,
    ) {
        let item = AnimationScriptManager.Scripts[id];
        if (!Utils.isNullOrUndefined(item)) {
            if (DEBUG) {
                Logger.errorGroup(
                    "AnimationScriptManager",
                    `Animation script with id '${id}' already exist. Please choose unique id!`,
                );
            }
            return;
        }

        try {
            AnimationScriptManager.Scripts[id] = factory;

            let assets = factory.assets || {};
            if (assets && Object.keys(assets).length) {
                for (let id in assets) {
                    let assetPath = assets[id];
                    assetPath = UriHelper.resolveUrl(baseUrl, assetPath);

                    loadAssetCallback(id, assetPath);
                }
            }
        } finally {
            loadAssetCallback(null, null);
        }
    }

    public static createInstance(id: string): PIXI.extras.AnimatedSprite {
        let item: AnimationScriptAnimationFactory = AnimationScriptManager.Scripts[id];
        if (Utils.isNullOrUndefined(item)) {
            if (DEBUG) {
                Logger.errorGroup("AnimationScriptManager", `Animation script with id '${id}' does not exist!`);
            }
            return null;
        }

        let cachedInstance = AnimationScriptManager._cachedInstances[id];
        if (Utils.isNullOrUndefined(cachedInstance)) {
            cachedInstance = new item() as PIXI.extras.AnimatedSprite;
            AnimationScriptManager._cachedInstances[id] = cachedInstance;

            if (DEBUG) {
                let cacheSize = ObjectUtils.keyCount(AnimationScriptManager._cachedInstances);
                Logger.debugGroup(
                    "AnimationScriptManager",
                    `Created new instance of '${id}' and added to cache, caching so far ${cacheSize} instances.`,
                );
            }
        } else {
            if (DEBUG) {
                Logger.debugGroup("AnimationScriptManager", `Returns cached instance of '${id}'.`);
            }
        }

        return cachedInstance;
        //return new item() as PIXI.extras.AnimatedSprite;
    }
}

window["AnimationScriptManager"] = AnimationScriptManager;



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Managers/AnimationScriptManager.ts
 **/